import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import AuthenticationModule from './modules/Authentication'
import SymptomCheckerModule from './modules/SymptomChecker'

export default new Vuex.Store({
    modules: {
        auth: AuthenticationModule,
        symptom: SymptomCheckerModule
    },
    debug: true
})